import { render, staticRenderFns } from "./AgendaItemTable.vue?vue&type=template&id=6536f56a"
import script from "./AgendaItemTable.vue?vue&type=script&lang=js"
export * from "./AgendaItemTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports